// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"49244adb","821":"fa3df040"}[chunkId] + ".chunk.js";
};